import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=5a9f0cae"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9f0cae')) {
      api.createRecord('5a9f0cae', component.options)
    } else {
      api.reload('5a9f0cae', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=5a9f0cae", function () {
      api.rerender('5a9f0cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicaid/Menu.vue"
export default component.exports